import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const SupportTickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");

  const fetchTickets = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/admin/tickets`);
      setTickets(Array.isArray(res.data) ? res.data : (res.data?.Tickets?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
    } catch (err) {
      console.error("Error fetching admin tickets", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const handleSendReply = async (e) => {
    e.preventDefault();
    if (!replyMessage || !selectedTicket) return;
    try {
      const res = await axios.post(`${API_BASE_URL}/api/admin/tickets/${selectedTicket._id}/reply`, {
        message: replyMessage,
      });
      setSelectedTicket(res.data.ticket);
      setReplyMessage("");
      fetchTickets();
    } catch (err) {
      alert("Failed to send admin reply");
    }
  };

  return (
    <div>
      <div style={{ marginBottom: "20px" }}>
        <h2 style={{ margin: 0, color: "#fff" }}>Support & Client Query Inbox</h2>
        <p style={{ margin: "4px 0 0", color: "#b2b5be", fontSize: "14px" }}>
          Respond to client inquiries regarding funds, paper trading, and KYC verification
        </p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: "20px" }}>
        {/* Ticket List */}
        <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", padding: "16px", border: "1px solid #2a2e39" }}>
          <h3 style={{ marginTop: 0, fontSize: "16px", color: "#fff" }}>Client Tickets ({tickets.length})</h3>
          {loading ? (
            <div style={{ color: "#888" }}>Loading support inbox...</div>
          ) : tickets.length === 0 ? (
            <div style={{ color: "#888", fontSize: "14px" }}>No support tickets in queue.</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {tickets.map((t) => (
                <div
                  key={t._id}
                  onClick={() => setSelectedTicket(t)}
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: selectedTicket?._id === t._id ? "2px solid #2962ff" : "1px solid #2a2e39",
                    backgroundColor: selectedTicket?._id === t._id ? "#2a2e39" : "#131722",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontWeight: "bold", fontSize: "14px", color: "#fff" }}>{t.subject}</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        backgroundColor: t.status === "open" ? "rgba(255, 152, 0, 0.15)" : t.status === "in_progress" ? "rgba(76, 175, 80, 0.15)" : "rgba(158, 158, 158, 0.15)",
                        color: t.status === "open" ? "#ff9800" : t.status === "in_progress" ? "#4caf50" : "#9e9e9e",
                      }}
                    >
                      {t.status.toUpperCase()}
                    </span>
                  </div>
                  <div style={{ fontSize: "12px", color: "#888", marginTop: "4px" }}>
                    Client: {t.userEmail} • Category: {t.category}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Ticket Reply Pane */}
        <div style={{ backgroundColor: "#1e222d", borderRadius: "8px", padding: "16px", border: "1px solid #2a2e39" }}>
          {selectedTicket ? (
            <div>
              <h3 style={{ marginTop: 0, color: "#2962ff" }}>{selectedTicket.subject}</h3>
              <div style={{ fontSize: "13px", color: "#b2b5be", marginBottom: "16px" }}>
                Client Email: <strong>{selectedTicket.userEmail}</strong> | Category: {selectedTicket.category}
              </div>

              <div style={{ backgroundColor: "#131722", padding: "12px", borderRadius: "6px", marginBottom: "16px", fontSize: "14px", color: "#fff", border: "1px solid #2a2e39" }}>
                <strong>Client Initial Inquiry:</strong>
                <div style={{ marginTop: "4px", color: "#d1d4dc" }}>{selectedTicket.message}</div>
              </div>

              <h4 style={{ fontSize: "14px", color: "#b2b5be" }}>Thread History ({selectedTicket.replies?.length || 0})</h4>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxHeight: "250px", overflowY: "auto", marginBottom: "16px" }}>
                {(selectedTicket.replies || []).map((r, idx) => (
                  <div
                    key={idx}
                    style={{
                      padding: "10px 14px",
                      borderRadius: "8px",
                      maxWidth: "85%",
                      alignSelf: r.senderRole === "admin" ? "flex-end" : "flex-start",
                      backgroundColor: r.senderRole === "admin" ? "rgba(41, 98, 255, 0.15)" : "rgba(76, 175, 80, 0.15)",
                      border: r.senderRole === "admin" ? "1px solid #2962ff" : "1px solid #4caf50",
                    }}
                  >
                    <div style={{ fontSize: "11px", fontWeight: "bold", color: r.senderRole === "admin" ? "#2962ff" : "#4caf50", marginBottom: "2px" }}>
                      {r.senderName} ({r.senderRole.toUpperCase()})
                    </div>
                    <div style={{ fontSize: "13px", color: "#fff" }}>{r.message}</div>
                    <div style={{ fontSize: "10px", color: "#888", textAlign: "right", marginTop: "4px" }}>
                      {new Date(r.createdAt).toLocaleTimeString()}
                    </div>
                  </div>
                ))}
              </div>

              <form onSubmit={handleSendReply} style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  value={replyMessage}
                  onChange={(e) => setReplyMessage(e.target.value)}
                  placeholder="Type official admin response..."
                  required
                  style={{ flex: 1, padding: "10px", borderRadius: "6px", border: "1px solid #363c4e", backgroundColor: "#131722", color: "#fff" }}
                />
                <button type="submit" style={btnStyle}>
                  Send Official Reply
                </button>
              </form>
            </div>
          ) : (
            <div style={{ padding: "40px", textAlign: "center", color: "#888" }}>
              Select a client inquiry on the left to review and send official responses.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const btnStyle = {
  padding: "10px 16px",
  backgroundColor: "#2962ff",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default SupportTickets;
